import { SignoffSpec } from '@/reports/types';
import { Signoff } from './ReportField';

interface SignOffsProps {
  /** the sign-off lines the report declares (`definition.signoffs`) */
  specs?: SignoffSpec[];
  /** the names typed on them, by role id (`values.signoffs`) */
  values?: Record<string, string>;
  /** absent when the reader cannot edit */
  onChange?: (values: Record<string, string>) => void;
}

/** The sign-off lines at the end of a report: one per role the report declares, each a name typed into the report. */
export function SignOffs({ specs = [], values = {}, onChange }: SignOffsProps) {
  if (specs.length === 0) return null;
  return (
    <div className="signoffs">
      {specs.map((spec) => (
        <Signoff
          key={spec.id}
          id={`signoff-${spec.id}`}
          role={spec.label}
          optional={spec.optional}
          value={values[spec.id] ?? ''}
          onChange={onChange ? (name) => onChange({ ...values, [spec.id]: name }) : undefined}
        />
      ))}
    </div>
  );
}

/** The typed names a report keeps in `values.signoffs`, by role. */
export function signoffValues(values: Record<string, unknown>): Record<string, string> {
  const raw = values.signoffs;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  return Object.fromEntries(Object.entries(raw as Record<string, unknown>).filter((e): e is [string, string] => typeof e[1] === 'string'));
}
